// 过程负责人审核(3)
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- tab栏 -->
    <ul class="topTabs">
      <!-- <li
        style="width:21%"
        @click="handleTopBarClikc('1')"
        :class="topBarActive==='1'?'topBarActiveBlue':''"
      >技术负责人审核表</li>
      <li
        style="width:26%"
        @click="handleTopBarClikc('2')"
        :class="topBarActive==='2'?'topBarActiveBlue':''"
      >技术负责人审核修改回复表</li>-->
      <li
        style="width:50%"
        @click="handleTopBarClikc('3')"
        :class="topBarActive==='3'?'topBarActiveBlue':''"
      >过程控制负责人审核表</li>
      <li
        style="width:50%"
        @click="handleTopBarClikc('4')"
        :class="topBarActive==='4'?'topBarActiveBlue':''"
      >过程控制负责人修改回复表</li>
    </ul>
    <!-- {1}技术负责人审核表 -->
    <div class="tabsItem" v-if="topBarActive==='1'">
      <!-- 第一行-项目名称 -->
      <div class="oneRow" style="margin-bottom:35px">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
          <span>项目名称</span>
        </div>
        <div class="rightInput">
          <span class="isNotSubmitSpan">{{S_project_name}}</span>
        </div>
      </div>
      <!-- 第二行-项目审核内容 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:17px" src="../../assets/image/icon_shenh@2x.png" alt />
          <span>项目审核内容</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
        <el-table
          :data="tableData1"
          style="width: 100%"
          border
          :header-cell-style="{background:'#F4F5F6'}"
        >
          <el-table-column show-overflow-tooltip align="center" prop="id" label="序号" width="50"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="content" label="内容"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="审核意见" width="350">
            <template slot-scope="scope">
              <div class="auditOpinion">
                <el-radio-group v-model="scope.row.radio" :disabled="!isSubmit1">
                  <el-radio :label="'0'">是</el-radio>
                  <el-radio :label="'1'">否</el-radio>
                  <el-radio :label="'2'">其他</el-radio>
                </el-radio-group>
                <el-input v-model="scope.row.other" :disabled="!isSubmit1"></el-input>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 第三行--文件格式、内容是否符合要求 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:17px" src="../../assets/image/icon_yx@2x.png" alt />
          <span>文件格式、内容是否符合要求</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
        <el-table
          :data="tableData2"
          style="width: 100%"
          border
          :header-cell-style="{background:'#F4F5F6'}"
        >
          <el-table-column show-overflow-tooltip align="center" prop="id" label="序号" width="50"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="content" label="内容"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="审核意见" width="250">
            <template slot-scope="scope">
              <div class="auditOpinion" style="justify-content: center;">
                <el-radio-group v-model="scope.row.radio" :disabled="!isSubmit1">
                  <el-radio :label="'0'">符合</el-radio>
                  <el-radio :label="'1'">不符合</el-radio>
                </el-radio-group>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 第四行--技术负责人审查意见 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:15px" src="../../assets/image/icon_yijian@2x.png" alt />
          <span>技术负责人审查意见</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
        <el-input
          :disabled="!isSubmit1"
          v-model="addFormData1.review_comments"
          type="textarea"
          :autosize="{minRows: 3}"
        ></el-input>
      </div>
      <!-- 签字 --1 -->
      <div class="writeName" style="margin-bottom:25px">
        <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
        <span style="width:140px">技术负责人签字</span>
        <img
          v-if="!addFormData1.sign_audit"
          @click="handleReceiverFlag1"
          style="width:66px;"
          src="../../assets/image/zaixianqianm@2x.png"
          alt
        />
        <img
          v-if="addFormData1.sign_audit"
          @click="handleReceiverFlag1(addFormData1.sign_audit)"
          style="width:66px;"
          :src="addFormData1.sign_audit"
          alt
        />
      </div>
      <!-- 第五行--上传附件 --1 -->
      <div class="oneRow">
        <div class="leftLabel upLoadLabel">
          <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
          <span>上传附件</span>
        </div>
        <div class="rightInput">
          <upload-file
            :isSubmit="isSubmit1"
            :imgList="this.addFormData1.annex"
            :detailsImgList="detailsImgList1"
            @my-upload-change="upLoadChange1"
          ></upload-file>
        </div>
      </div>

      <!-- 审批备注 -->
      <div
        class="oneRow"
        style="margin-bottom:35px;margin-top:20px"
        v-if="addFormData1.is_approve==1"
      >
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
          <span>审批备注</span>
        </div>
        <div class="rightInput">
          <el-input v-model="approval_remark1"></el-input>
        </div>
      </div>

      <!-- 按钮行 -->
      <div class="btnRow">
        <el-button @click="handleSubmit1('1')" v-if="addFormData1.is_edit!='1'">保存草稿</el-button>
        <el-button
          v-if="addFormData1.withdraw_status=='1'"
          @click="handleProjectWithDraw1"
          style="background-color:rgb(255, 26, 26);"
        >撤回</el-button>
        <el-button
          style="background-color:#40A0F2"
          @click="handleSubmit1('0')"
          v-if="addFormData1.is_edit!='1'"
        >提交</el-button>
        <el-button
          v-if="addFormData1.is_approve==1"
          @click="handleExamine1('-1')"
          style="background-color:#f4a029"
        >驳回</el-button>
        <el-button
          v-if="addFormData1.is_approve==1"
          @click="handleExamine1('1')"
          style="background-color:#40A0F2"
        >审批通过</el-button>
      </div>
      <!-- 按钮行 -->
    </div>
    <!-- {2}技术负责人审核修改回复表 -->
    <div class="tabsItem" v-if="topBarActive==='2'">
      <!-- 第一行-项目名称 -->
      <div class="oneRow" style="margin-bottom:35px">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
          <span>项目名称</span>
        </div>
        <div class="rightInput">
          <span class="isNotSubmitSpan">{{S_project_name}}</span>
        </div>
      </div>
      <!-- 第二行--修改记录 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:15px" src="../../assets/image/icon_xgjl@2x.png" alt />
          <span>修改记录</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
        <el-input
          v-model="addFormData2.modification_record"
          :disabled="!isSubmit2"
          type="textarea"
          :autosize="{minRows: 3}"
        ></el-input>
      </div>
      <!-- 签字 --2 --3 -->
      <div class="writeName" style="margin-bottom:10px">
        <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
        <span style="width:100px">修改人确认</span>
        <!-- 2 -->
        <img
          v-if="!addFormData2.sign_modifier"
          @click="handleReceiverFlag2"
          style="width:66px;"
          src="../../assets/image/zaixianqianm@2x.png"
          alt
        />
        <img
          v-if="addFormData2.sign_modifier"
          @click="handleReceiverFlag2(addFormData2.sign_modifier)"
          style="width:66px;"
          :src="addFormData2.sign_modifier"
          alt
        />
      </div>
      <div class="writeName" style="margin-bottom:25px">
        <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
        <span style="width:130px">技术负责人确认</span>
        <!-- 3 -->
        <img
          v-if="!addFormData2.confirm_sign_audit"
          @click="handleReceiverFlag3"
          style="width:66px;"
          src="../../assets/image/zaixianqianm@2x.png"
          alt
        />
        <img
          v-if="addFormData2.confirm_sign_audit"
          @click="handleReceiverFlag3(addFormData2.confirm_sign_audit)"
          style="width:66px;"
          :src="addFormData2.confirm_sign_audit"
          alt
        />
      </div>
      <!-- 第三行--日期 -->
      <div class="rightTimeRow" style="margin-bottom:30px">
        <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
        <span style="color:#333;margin:0 10px">日期</span>
        <el-date-picker
          :disabled="!isSubmit2"
          v-model="addFormData2.confirm_date"
          type="date"
          :placeholder="isSubmit2 ? '选择日期' : ''"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <!-- 第四行--上传附件-2 -->
      <div class="oneRow">
        <div class="leftLabel upLoadLabel">
          <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
          <span>上传附件</span>
        </div>
        <div class="rightInput">
          <upload-files
            :isSubmit="isSubmit2"
            :imgList="this.addFormData2.confirm_annex"
            :detailsImgList="detailsImgList2"
            @my-upload-change="upLoadChange2"
          ></upload-files>
        </div>
      </div>

      <!-- 审批备注 -->
      <div
        class="oneRow"
        style="margin-bottom:35px;margin-top:20px"
        v-if="addFormData2.is_approve==1"
      >
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
          <span>审批备注</span>
        </div>
        <div class="rightInput">
          <el-input v-model="approval_remark2"></el-input>
        </div>
      </div>

      <!-- 按钮行 -->
      <div class="btnRow">
        <el-button @click="handleSubmit2('1')" v-if="addFormData2.is_edit!='1'">保存草稿</el-button>
        <el-button
          v-if="addFormData2.withdraw_status=='1'"
          @click="handleProjectWithDraw2"
          style="background-color:rgb(255, 26, 26);"
        >撤回</el-button>
        <el-button
          style="background-color:#40A0F2"
          @click="handleSubmit2('0')"
          v-if="addFormData2.is_edit!='1'"
        >提交</el-button>
        <el-button
          v-if="addFormData2.is_approve==1"
          @click="handleExamine2('-1')"
          style="background-color:#f4a029"
        >驳回</el-button>
        <el-button
          v-if="addFormData2.is_approve==1"
          @click="handleExamine2('1')"
          style="background-color:#40A0F2"
        >审批通过</el-button>
      </div>
      <!-- 按钮行 -->
    </div>
    <!-- {3}过程控制负责人审核表 -->
    <div class="tabsItem" v-if="topBarActive==='3'">
      <!-- 第一行-项目名称 -->
      <div class="oneRow" style="margin-bottom:35px">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
          <span>项目名称</span>
        </div>
        <div class="rightInput">
          <span class="isNotSubmitSpan">{{S_project_name}}</span>
        </div>
      </div>
      <!-- 第二行-项目审核内容 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:17px" src="../../assets/image/icon_shenh@2x.png" alt />
          <span>项目审核内容</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
        <el-table
          :data="tableData3"
          style="width: 100%"
          border
          :header-cell-style="{background:'#F4F5F6'}"
        >
          <el-table-column show-overflow-tooltip align="center" prop="id" label="序号" width="50"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="content" label="内容"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="审核意见" width="300">
            <template slot-scope="scope">
              <div class="auditOpinion" style="display:flex;justify-content: center;">
                <el-radio-group v-model="scope.row.radio" :disabled="!isSubmit3">
                  <el-radio :label="'0'">有</el-radio>
                  <el-radio :label="'1'">无</el-radio>
                </el-radio-group>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 第三行--出版情况 -->
      <!-- <div class="oneRow" style="margin-bottom:35px">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_cbqk@2x.png" alt />
          <span>出版情况</span>
        </div>
        <div class="rightInput">
          <el-radio-group v-model="addFormData3.publication" :disabled="!isSubmit3">
            <el-radio :label="'改后重审'"></el-radio>
            <el-radio :label="'改后出版'"></el-radio>
            <el-radio :label="'直接出版'"></el-radio>
          </el-radio-group>
        </div>
      </div>-->
      <!-- 第四行--技术负责人审查意见 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:15px" src="../../assets/image/icon_yijian@2x.png" alt />
          <span>过程控制负责人审核意见</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
        <el-input
          v-model="addFormData3.suggestions"
          :disabled="!isSubmit3"
          type="textarea"
          :autosize="{minRows: 3}"
        ></el-input>
      </div>
      <!-- 签字 --4 -->
      <!-- <div class="writeName" style="margin-bottom:25px">
        <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
        <span style="width:170px">过程控制负责人签字</span>
        <img
          v-if="!addFormData3.sign_control"
          @click="handleReceiverFlag4"
          style="width:66px;"
          src="../../assets/image/zaixianqianm@2x.png"
          alt
        />
        <img
          v-if="addFormData3.sign_control"
          @click="handleReceiverFlag4(addFormData3.sign_control)"
          style="width:66px;"
          :src="addFormData3.sign_control"
          alt
        />
      </div>-->
      <!-- 第五行--上传附件--3 -->
      <div class="oneRow">
        <div class="leftLabel upLoadLabel">
          <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
          <span>上传附件</span>
        </div>
        <div class="rightInput">
          <upload-filess
            :isSubmit="isSubmit3"
            :imgList="this.addFormData3.thr_annex"
            :detailsImgList="detailsImgList3"
            @my-upload-change="upLoadChange3"
          ></upload-filess>
        </div>
      </div>
      <div class="oneRow" style="margin-bottom:30px">
        <div class="leftLabel"></div>
        <div class="rightInput" style="display:flex;align-items:center">
          <div style="color:rgb(245, 95, 95);font-size:12px;">*请上传过控负责人审核表,模板文件：</div>
          <a
            style="font-size:14px;"
            href="http://control.sxpz.vip/Template/过控负责人审核表.doc"
          >过控负责人审核表.doc</a>
        </div>
      </div>

      <!-- 审批备注 -->
      <div
        class="oneRow"
        style="margin-bottom:35px;margin-top:20px"
        v-if="addFormData3.is_approve==1"
      >
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
          <span>审批备注</span>
        </div>
        <div class="rightInput">
          <el-input v-model="approval_remark3"></el-input>
        </div>
      </div>

      <!-- 按钮行 -->
      <div class="btnRow">
        <el-button @click="handleSubmit3('1')" v-if="addFormData3.is_edit!='1'">保存草稿</el-button>
        <el-button
          v-if="addFormData3.withdraw_status=='1'"
          @click="handleProjectWithDraw3"
          style="background-color:rgb(255, 26, 26);"
        >撤回</el-button>
        <el-button
          style="background-color:#40A0F2"
          @click="handleSubmit3('0')"
          v-if="addFormData3.is_edit!='1'"
        >提交</el-button>
        <el-button
          v-if="addFormData3.is_approve==1"
          @click="handleExamine3('-1')"
          style="background-color:#f4a029"
        >驳回</el-button>
        <el-button
          v-if="addFormData3.is_approve==1"
          @click="handleExamine3('1')"
          style="background-color:#40A0F2"
        >审批通过</el-button>
      </div>
      <!-- 按钮行 -->
    </div>
    <!-- {4}过程控制负责人修改回复表 -->
    <div class="tabsItem" v-if="topBarActive==='4'">
      <!-- 第一行-项目名称 -->
      <div class="oneRow" style="margin-bottom:35px">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
          <span>项目名称</span>
        </div>
        <div class="rightInput">
          <span class="isNotSubmitSpan">{{S_project_name}}</span>
        </div>
      </div>
      <!-- 第二行--修改记录 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:15px" src="../../assets/image/icon_xgjl@2x.png" alt />
          <span>修改记录</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
        <el-input
          :disabled="!isSubmit4"
          v-model="addFormData4.four_modification_record"
          type="textarea"
          :autosize="{minRows: 3}"
        ></el-input>
      </div>
      <!-- 签字 --5 --6 -->
      <!-- <div class="writeName" style="margin-bottom:10px">
        <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
        <span style="width:100px">修改人确认</span>
        <img
          v-if="!addFormData4.four_sign_modifier"
          @click="handleReceiverFlag5"
          style="width:66px;"
          src="../../assets/image/zaixianqianm@2x.png"
          alt
        />
        <img
          v-if="addFormData4.four_sign_modifier"
          @click="handleReceiverFlag5(addFormData4.four_sign_modifier)"
          style="width:66px;"
          :src="addFormData4.four_sign_modifier"
          alt
        />
      </div>
      <div class="writeName" style="margin-bottom:25px">
        <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
        <span style="width:130px">技术负责人确认</span>
        <img
          v-if="!addFormData4.four_confirm_sign_audit"
          @click="handleReceiverFlag6"
          style="width:66px;"
          src="../../assets/image/zaixianqianm@2x.png"
          alt
        />
        <img
          v-if="addFormData4.four_confirm_sign_audit"
          @click="handleReceiverFlag6(addFormData4.four_confirm_sign_audit)"
          style="width:66px;"
          :src="addFormData4.four_confirm_sign_audit"
          alt
        />
      </div>-->
      <!-- 第三行--日期 -->
      <div class="rightTimeRow" style="margin-bottom:30px">
        <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
        <span style="color:#333;margin:0 10px">日期</span>
        <el-date-picker
          :disabled="!isSubmit4"
          v-model="addFormData4.four_confirm_date"
          type="date"
          :placeholder="isSubmit4 ? '选择日期' : ''"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <!-- 第四行--上传附件 --4 -->
      <div class="oneRow">
        <div class="leftLabel upLoadLabel">
          <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
          <span>上传附件</span>
        </div>
        <div class="rightInput">
          <upload-filesss
            :isSubmit="isSubmit4"
            :imgList="this.addFormData4.four_annex"
            :detailsImgList="detailsImgList4"
            @my-upload-change="upLoadChange4"
          ></upload-filesss>
        </div>
      </div>

      <!-- 审批备注 -->
      <div
        class="oneRow"
        style="margin-bottom:35px;margin-bottom:20px"
        v-if="addFormData4.is_approve==1"
      >
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
          <span>审批备注</span>
        </div>
        <div class="rightInput">
          <el-input v-model="approval_remark4"></el-input>
        </div>
      </div>

      <!-- 按钮行 -->
      <div class="btnRow">
        <el-button @click="handleSubmit4('1')" v-if="addFormData4.is_edit!='1'">保存草稿</el-button>
        <el-button
          v-if="addFormData4.withdraw_status=='1'"
          @click="handleProjectWithDraw4"
          style="background-color:rgb(255, 26, 26);"
        >撤回</el-button>
        <el-button
          style="background-color:#40A0F2"
          @click="handleSubmit4('0')"
          v-if="addFormData4.is_edit!='1'"
        >提交</el-button>
        <el-button
          v-if="addFormData4.is_approve==1"
          @click="handleExamine4('-1')"
          style="background-color:#f4a029"
        >驳回</el-button>
        <el-button
          v-if="addFormData4.is_approve==1"
          @click="handleExamine4('1')"
          style="background-color:#40A0F2"
        >审批通过</el-button>
      </div>
      <!-- 按钮行 -->
    </div>
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone1"
      :visible.sync="receiverSignFlag1"
      @change="handleReceiverSign"
    ></sign-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone2"
      :visible.sync="receiverSignFlag2"
      @change="handleReceiverSign"
    ></sign-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone3"
      :visible.sync="receiverSignFlag3"
      @change="handleReceiverSign"
    ></sign-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone4"
      :visible.sync="receiverSignFlag4"
      @change="handleReceiverSign"
    ></sign-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone5"
      :visible.sync="receiverSignFlag5"
      @change="handleReceiverSign"
    ></sign-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone6"
      :visible.sync="receiverSignFlag6"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 签名组件 -->

    <project-flow
      class="modifyFlow"
      v-if="this.addFormData1.approval_log && this.addFormData1.approval_log.length>0 && topBarActive==='1'"
      :projectFlowLog="this.addFormData1.approval_log"
      :projectName="this.addFormData1.project_name"
      :companyName="this.addFormData1.company_name"
      :projectId="this.addFormData1.project_id"
      :stageCode="'321'"
    ></project-flow>
    <project-flow
      class="modifyFlow"
      v-if="this.addFormData2.approval_log && this.addFormData2.approval_log.length>0 && topBarActive==='2'"
      :projectFlowLog="this.addFormData2.approval_log"
      :projectName="this.addFormData2.project_name"
      :companyName="this.addFormData2.company_name"
      :projectId="this.addFormData2.project_id"
      :stageCode="'322'"
    ></project-flow>
    <project-flow
      class="modifyFlow"
      v-if="this.addFormData3.approval_log && this.addFormData3.approval_log.length>0 && topBarActive==='3'"
      :projectFlowLog="this.addFormData3.approval_log"
      :projectName="this.addFormData3.project_name"
      :companyName="this.addFormData3.company_name"
      :projectId="this.addFormData3.project_id"
      :stageCode="'323'"
    ></project-flow>
    <project-flow
      class="modifyFlow"
      v-if="this.addFormData4.approval_log && this.addFormData4.approval_log.length>0 && topBarActive==='4'"
      :projectFlowLog="this.addFormData4.approval_log"
      :projectName="this.addFormData4.project_name"
      :companyName="this.addFormData4.company_name"
      :projectId="this.addFormData4.project_id"
      :stageCode="'324'"
    ></project-flow>

    <go-finance
      class="modifyFlow"
      v-if="this.addFormData1.approval_log && this.addFormData1.approval_log.length>0 && topBarActive==='1'"
      :projectId="this.addFormData1.project_id"
    ></go-finance>
    <go-finance
      class="modifyFlow"
      v-if="this.addFormData2.approval_log && this.addFormData2.approval_log.length>0 && topBarActive==='2'"
      :projectId="this.addFormData2.project_id"
    ></go-finance>
    <go-finance
      class="modifyFlow"
      v-if="this.addFormData3.approval_log && this.addFormData3.approval_log.length>0 && topBarActive==='3'"
      :projectId="this.addFormData3.project_id"
    ></go-finance>
    <go-finance
      class="modifyFlow"
      v-if="this.addFormData4.approval_log && this.addFormData4.approval_log.length>0 && topBarActive==='4'"
      :projectId="this.addFormData4.project_id"
    ></go-finance>

    <!-- 签名详情弹窗 -->
    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia imgDetailsDia"
      :before-close="showDetailsDiaClose"
    >
      <div class="diaContainer">
        <img :src="showDetailsSign" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import SignDialog from '../SignDialog'
import UploadFile from '../UploadFile'
import UploadFiles from '../UploadFile'
import UploadFiless from '../UploadFile'
import UploadFilesss from '../UploadFile'
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      showDetailsSign: '',
      showDetailsDia: false,

      S_project_name: '',
      approval_remark1: '',
      approval_remark2: '',
      approval_remark3: '',
      approval_remark4: '',
      isSubmit1: true,
      isSubmit2: true,
      isSubmit3: true,
      isSubmit4: true,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      // 文件上传组件
      detailsImgList1: [],
      detailsImgList2: [],
      detailsImgList3: [],
      detailsImgList4: [],
      submitImgList1: [],
      submitImgList2: [],
      submitImgList3: [],
      submitImgList4: [],
      // 文件上传组件
      // 签名
      receiverSignFlag1: false,
      receiverSignFlag2: false,
      receiverSignFlag3: false,
      writeDoneImg1: '',
      writeDoneImg2: '',
      writeDoneImg3: '',

      addFormData1: {
        // json附件
        annex: '',
        // 项目审核内容
        audit_content: '',
        // 文件格式审查意见
        document_format: '',
        // 	项目内容审查意见
        review_comments: '',
        // 审核负责人签字
        sign_audit: '',
      },
      addFormData2: {
        // json附件
        confirm_annex: '',
        // 修改记录
        modification_record: '',
        // 修改人确认
        sign_modifier: '',
        // 审核负责人确认
        confirm_sign_audit: '',
        // 日期
        confirm_date: '',
      },
      addFormData3: {
        // json附件
        thr_annex: '',
        // 审核意见json
        audit_opinion: '',
        // 出版情况
        // publication: '',
        // 过程控制负责人审核意见
        suggestions: '',
        // 过程控制负责人签字
        // sign_control: '',
      },
      addFormData4: {
        // json附件
        four_annex: '',
        // 修改记录
        four_modification_record: '',
        // 修改人确认
        four_sign_modifier: '',
        // 技术负责人确认
        four_confirm_sign_audit: '',
        // 日期
        four_confirm_date: '',
      },
      // 签名
      receiverSignFlag1: false,
      receiverSignFlag2: false,
      receiverSignFlag3: false,
      receiverSignFlag4: false,
      receiverSignFlag5: false,
      receiverSignFlag6: false,
      writeDoneImg1: '',
      writeDoneImg2: '',
      writeDoneImg3: '',
      writeDoneImg4: '',
      writeDoneImg5: '',
      writeDoneImg6: '',
      // 签名
      topBarActive: '3',
      infop: '',
      value: '',
      tableData1: [
        {
          id: 1,
          content: '现场收集材料是否齐全有效',
          radio: '0',
          other: '',
        },
        {
          id: 2,
          content: '危险有害因素识别是否充分',
          radio: '0',
          other: '',
        },
        {
          id: 3,
          content: '评价方法是否合理',
          radio: '0',
          other: '',
        },
        {
          id: 4,
          content: '对策措施是否有针对性',
          radio: '0',
          other: '',
        },
        {
          id: 5,
          content: '结论是否正确',
          radio: '0',
          other: '',
        },
      ],
      tableData2: [
        {
          id: 1,
          content: '编排格式',
          radio: '1',
        },
        {
          id: 2,
          content: '内容、技术文件附录、附件',
          radio: '1',
        },
        {
          id: 3,
          content: '其他',
          radio: '1',
        },
      ],

      tableData3: [
        {
          id: 1,
          // content: '企业情况调查表',
          content: '审核意见',
          radio: '0',
        },
        {
          id: 2,
          // content: '企业安全评价委托书',
          content: '企业情况调查表',
          radio: '0',
        },
        {
          id: 3,
          // content: '项目风险分析记录',
          content: '企业安全评价委托书',
          radio: '0',
        },
        {
          id: 4,
          // content: '项目成员任命书',
          content: '项目风险分析记录',
          radio: '0',
        },
        {
          id: 5,
          // content: '项目方案',
          content: '项目成员任命书 ',
          radio: '0',
        },
        {
          id: 6,
          // content: '委托方提供资料清单',
          content: '项目计划书',
          radio: '0',
        },
        {
          id: 7,
          // content: '现场影像记录',
          content: '委托方提供资料清单',
          radio: '0',
        },
        {
          id: 8,
          // content: '现场勘察、意见记录表',
          content: '相关类比资料（针对预评价项目）',
          radio: '0',
        },
        {
          id: 9,
          // content: '项目整改通知单',
          content: '现场影像记录 ',
          radio: '0',
        },
        {
          id: 10,
          // content: '整改报告 （由企业提供）',
          content: '现场勘察、意见记录表',
          radio: '0',
        },
        {
          id: 11,
          // content: '项目整改复查记录表',
          content: '项目整改通知单',
          radio: '0',
        },
        {
          id: 12,
          // content: '报告内部审核记录、修改回复',
          content: '整改报告 （由企业提供）',
          radio: '0',
        },
        {
          id: 13,
          // content: '报告外部审核记录、修改回复',
          content: '项目整改复查记录表',
          radio: '0',
        },
        {
          id: 14,
          // content: '技术负责人审核记录、修改回复',
          content: '报告内部审核记录',
          radio: '0',
        },
        {
          id: 15,
          // content: '过程控制负责人审核记录、修改回复',
          content: '技术负责人审核记录',
          radio: '0',
        },
        {
          id: 16,
          // content: '安全评价报告三审稿（纸质、电子版）',
          content: '过程控制负责人审核记录',
          radio: '0',
        },
        {
          id: 17,
          // content: '安全评价报告附件',
          content: '安全评价报告三审稿（纸质、电子版）',
          radio: '0',
        },
        {
          id: 18,
          // content: '安全评价合同 ',
          content: '专家评审意见',
          radio: '0',
        },
        {
          id: 19,
          // content: '客户意见反馈表',
          content: '安全评价报告附件',
          radio: '0',
        },
        {
          id: 20,
          // content: '客户意见反馈表',
          content: '安全评价合同',
          radio: '0',
        },
        {
          id: 21,
          // content: '客户意见反馈表',
          content: '客户意见反馈表',
          radio: '0',
        },
      ],
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目1
    async handleProjectWithDraw1() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails1()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // *撤回项目2
    async handleProjectWithDraw2() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails2()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // *撤回项目3
    async handleProjectWithDraw3() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails3()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // *撤回项目4
    async handleProjectWithDraw4() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails4()
      }, this.timeDou)
    },
    // *审批提交-4
    async handleExamine4(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark4)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/authorize4_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails4()
      }, this.timeDou)
    },
    // *审批提交-3
    async handleExamine3(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark3)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/authorize3_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails3()
      }, this.timeDou)
    },
    // *审批提交-2
    async handleExamine2(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark2)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/authorize2_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails2()
      }, this.timeDou)
    },
    // *审批提交-1
    async handleExamine1(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark1)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/authorize1_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails1()
      }, this.timeDou)
    },
    // *编辑提交-4
    async handleSubmit4(val) {
      if (
        this.addFormData4.four_confirm_date == 'null' ||
        this.addFormData4.four_confirm_date == null
      ) {
        this.addFormData4.four_confirm_date = ''
      }
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)

        param.append('four_annex', JSON.stringify(this.submitImgList4))

        param.append(
          'four_modification_record',
          this.addFormData4.four_modification_record
        )
        // param.append('four_sign_modifier', this.addFormData4.four_sign_modifier)
        // param.append(
        //   'four_confirm_sign_audit',
        //   this.addFormData4.four_confirm_sign_audit
        // )
        param.append('four_confirm_date', this.addFormData4.four_confirm_date)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/authorize4',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails4()
      }, this.timeDou)
    },
    // *编辑提交-3
    async handleSubmit3(val) {
      this.addFormData3.audit_opinion = JSON.stringify(this.tableData3)
      if (
        this.addFormData3.suggestions == null ||
        this.addFormData3.suggestions == 'null'
      ) {
        this.addFormData3.suggestions = ''
      }

      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)

        param.append('thr_annex', JSON.stringify(this.submitImgList3))

        param.append('audit_opinion', this.addFormData3.audit_opinion)
        // param.append('publication', this.addFormData3.publication)
        param.append('suggestions', this.addFormData3.suggestions)

        // param.append('sign_control', this.addFormData3.sign_control)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/authorize3',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails3()
      }, this.timeDou)
    },
    // *编辑提交-2
    async handleSubmit2(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)

        param.append('confirm_annex', JSON.stringify(this.submitImgList2))
        param.append(
          'modification_record',
          this.addFormData2.modification_record
        )
        param.append('sign_modifier', this.addFormData2.sign_modifier)
        param.append('confirm_sign_audit', this.addFormData2.confirm_sign_audit)
        param.append('confirm_date', this.addFormData2.confirm_date)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/authorize2',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails2()
      }, this.timeDou)
    },
    // *编辑提交-1
    async handleSubmit1(val) {
      this.addFormData1.audit_content = JSON.stringify(this.tableData1)
      this.addFormData1.document_format = JSON.stringify(this.tableData2)

      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)

        param.append('annex', JSON.stringify(this.submitImgList1))
        param.append('audit_content', this.addFormData1.audit_content)
        param.append('document_format', this.addFormData1.document_format)
        param.append('review_comments', this.addFormData1.review_comments)

        param.append('sign_audit', this.addFormData1.sign_audit)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/authorize1',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails1()
      }, this.timeDou)
    },
    // *获取详情-4
    async getProjectDetails4() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/authorize4_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData4 = res.datas.info
      } else {
        this.addFormData4.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (
        this.addFormData4.is_draft != '1' &&
        this.addFormData4.is_edit == '1'
      ) {
        this.isSubmit4 = false
      } else {
        this.isSubmit4 = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断文件上传
      if (this.addFormData4.four_annex) {
        this.detailsImgList4 = this.addFormData4.four_annex
        this.submitImgList4 = this.addFormData4.four_annex
      }
      if (
        this.addFormData4.four_modification_record == 'undefined' ||
        this.addFormData4.four_modification_record == 'null' ||
        this.addFormData4.four_modification_record == null
      ) {
        this.addFormData4.four_modification_record = ''
      }
      // 判断签名
      // if (
      //   this.addFormData4.four_sign_modifier == 'undefined' ||
      //   this.addFormData4.four_sign_modifier == 'null'
      // ) {
      //   this.addFormData4.four_sign_modifier = ''
      // }
      // if (
      //   this.addFormData4.four_confirm_sign_audit == 'undefined' ||
      //   this.addFormData4.four_confirm_sign_audit == 'null'
      // ) {
      //   this.addFormData4.four_confirm_sign_audit = ''
      // }
      // 判断日期
      if (
        this.addFormData4.four_confirm_date == 'undefined' ||
        this.addFormData4.four_confirm_date == 'null'
      ) {
        this.addFormData4.four_confirm_date = ''
      }
      this.isComponentsShow = true
      console.log('4技术负责人审核表', this.addFormData4)
    },
    // *获取详情-3
    async getProjectDetails3() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/authorize3_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData3 = res.datas.info
      } else {
        this.addFormData3.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (
        this.addFormData3.is_draft != '1' &&
        this.addFormData3.is_edit == '1'
      ) {
        this.isSubmit3 = false
      } else {
        this.isSubmit3 = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断文件上传
      if (this.addFormData3.thr_annex) {
        this.detailsImgList3 = this.addFormData3.thr_annex
        this.submitImgList3 = this.addFormData3.thr_annex
      }
      // 判断表格
      if (this.addFormData3.audit_opinion) {
        this.tableData3 = this.addFormData3.audit_opinion
      }
      // 判断签名
      // if (
      //   this.addFormData3.sign_control == 'undefined' ||
      //   this.addFormData3.sign_control == 'null'
      // ) {
      //   this.addFormData3.sign_control = ''
      // }
      this.isComponentsShow = true
      console.log('3技术负责人审核表', this.addFormData3)
    },
    // *获取详情-2
    async getProjectDetails2() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/authorize2_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData2 = res.datas.info
      } else {
        this.addFormData2.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (
        this.addFormData2.is_draft != '1' &&
        this.addFormData2.is_edit == '1'
      ) {
        this.isSubmit2 = false
      } else {
        this.isSubmit2 = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断文件上传
      if (this.addFormData2.confirm_annex) {
        this.detailsImgList2 = this.addFormData2.confirm_annex
        this.submitImgList2 = this.addFormData2.confirm_annex
      }
      // 判断签名
      if (
        this.addFormData2.sign_modifier == 'undefined' ||
        this.addFormData2.sign_modifier == 'null'
      ) {
        this.addFormData2.sign_modifier = ''
      }
      if (
        this.addFormData2.confirm_sign_audit == 'undefined' ||
        this.addFormData2.confirm_sign_audit == 'null'
      ) {
        this.addFormData2.confirm_sign_audit = ''
      }
      // 判断日期
      if (
        this.addFormData2.confirm_date == 'undefined' ||
        this.addFormData2.confirm_date == 'null'
      ) {
        this.addFormData2.confirm_date = ''
      }
      this.isComponentsShow = true
      console.log('2技术负责人审核表', this.addFormData2)
    },
    // *获取详情-1
    async getProjectDetails1() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/authorize1_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      if (res.datas.info.is_new != 1) {
        this.addFormData1 = res.datas.info
      } else {
        this.addFormData1.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (
        this.addFormData1.is_draft != '1' &&
        this.addFormData1.is_edit == '1'
      ) {
        this.isSubmit1 = false
      } else {
        this.isSubmit1 = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断文件上传
      if (this.addFormData1.annex) {
        this.detailsImgList1 = this.addFormData1.annex
        this.submitImgList1 = this.addFormData1.annex
      }
      // 判断表格
      if (this.addFormData1.audit_content) {
        this.tableData1 = this.addFormData1.audit_content
      }
      if (this.addFormData1.document_format) {
        this.tableData2 = this.addFormData1.document_format
      }
      // 判断签名
      if (
        this.addFormData1.sign_audit == 'undefined' ||
        this.addFormData1.sign_audit == 'null'
      ) {
        this.addFormData1.sign_audit = ''
      }
      this.isComponentsShow = true
      console.log('1技术负责人审核表', this.addFormData1)
    },
    // 文件上传
    upLoadChange1(data) {
      console.log('文件列表1', data)
      this.submitImgList1 = data
    },
    upLoadChange2(data) {
      console.log('文件列表2', data)
      this.submitImgList2 = data
    },
    upLoadChange3(data) {
      console.log('文件列表3', data)
      this.submitImgList3 = data
    },
    upLoadChange4(data) {
      console.log('文件列表4', data)
      this.submitImgList4 = data
    },
    // 签名
    handleWriteDone1(data) {
      this.addFormData1.sign_audit = data
    },
    handleWriteDone2(data) {
      this.addFormData2.sign_modifier = data
    },
    handleWriteDone3(data) {
      this.addFormData2.confirm_sign_audit = data
    },
    handleWriteDone4(data) {
      this.addFormData3.sign_control = data
    },
    handleWriteDone5(data) {
      this.addFormData4.four_sign_modifier = data
    },
    handleWriteDone6(data) {
      this.addFormData4.four_confirm_sign_audit = data
    },

    handleReceiverFlag1(url) {
      if (!this.isSubmit1) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag1 = true
    },
    handleReceiverFlag2(url) {
      if (!this.isSubmit2) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag2 = true
    },
    handleReceiverFlag3(url) {
      if (!this.isSubmit2) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag3 = true
    },
    handleReceiverFlag4(url) {
      if (!this.isSubmit3) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag4 = true
    },
    handleReceiverFlag5(url) {
      if (!this.isSubmit4) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag5 = true
    },
    handleReceiverFlag6(url) {
      if (!this.isSubmit4) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag6 = true
    },
    handleReceiverSign() {},
    // 签名
    handleTopBarClikc(val) {
      if (this.details_project_status == '321') {
        return
      } else if (
        this.details_project_status == '322' &&
        (val == '3' || val == '4')
      ) {
        return
      } else if (this.details_project_status == '323' && val == '4') {
        return
      }
      this.topBarActive = val
      if (val == '1') {
        this.getProjectDetails1()
      }
      if (val == '2') {
        this.getProjectDetails2()
      }
      if (val == '3') {
        this.getProjectDetails3()
      }
      if (val == '4') {
        this.getProjectDetails4()
      }
    },
    showDetailsDiaClose() {
      this.showDetailsDia = false
    },
    async getProjectStatus() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/get_project_status',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.details_project_status = res.datas.project_status
      if (this.details_project_status) {
        if (this.details_project_status == '321') {
          this.topBarActive = '1'
        }
        if (this.details_project_status == '322') {
          this.topBarActive = '2'
        }
        if (this.details_project_status == '323') {
          this.topBarActive = '3'
        }
        if (this.details_project_status == '324') {
          this.topBarActive = '4'
        }
      }
      if (this.details_project_status && this.details_project_id) {
        if (this.details_project_status == '321') {
          this.getProjectDetails1()
        } else if (this.details_project_status == '322') {
          this.getProjectDetails2()
        } else if (this.details_project_status == '323') {
          this.getProjectDetails3()
        } else if (this.details_project_status == '324') {
          this.getProjectDetails4()
        } else {
          this.getProjectDetails3()
        }
      }
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    if (this.details_project_id) {
      this.getProjectStatus()
    }
  },
  components: {
    SignDialog,
    UploadFile,
    UploadFiles,
    UploadFiless,
    UploadFilesss,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
/deep/.modifyFlow .projectFlowBtn {
  top: 70px !important;
}
/deep/.modifyFlow .goFinanceBtn {
  top: 120px !important;
}
</style>